export enum SurveyType {
  SMS = 'SMS',
  VOCAL = 'VOCAL',
  WEB = 'WEB',
  URL = 'URL',
  CHAT = 'CHAT',
}
